export default __webpack_public_path__ + "static/estimulamos-autonomia-1024db92fd15ee08352a262e83c900a8.png";